import calcTimeDifference from '@/utils/calc-time-difference'
import { minutesToHoursMinsString } from '@/utils/minutes-to-hours-mins-string'

/**
 * Generates a list of break minutes for the breaks select dropdown
 * @param {String} startTime 'HH:mm'
 * @param {String} endTime 'HH:mm'
 * @param {Number} incrementInMinutes
 * @param {Number} startIndex Indicates the index that the break mins list should be generated from. Default 0 (0 minutes)
 * @returns {Array} List of breaks
 * @notes Logic provided by BBB
 */
export default function generateBreakMinutesList(
  startTime,
  endTime,
  incrementInMinutes = 15,
  startIndex = 0
) {
  if (typeof incrementInMinutes !== 'number')
    throw Error('Invalid data type for increment (Expected Number)')

  if (typeof startIndex !== 'number')
    throw Error('Invalid data type for start index (Expected Number)')

  const bookingDurationInMins = calcTimeDifference(
    startTime,
    endTime,
    'minutes'
  )

  const breaks = []

  // Generate a list of options for the breaks select input
  // e.g. 0 minutes, 30 minutes etc..
  let minutes = 0
  for (
    let index = startIndex;
    index <= bookingDurationInMins / incrementInMinutes;
    ++index
  ) {
    minutes = index * incrementInMinutes
    breaks.push({
      id: minutes,
      text: minutesToHoursMinsString(minutes),
    })
  }

  return breaks
}
